<script>
    import { client, gql } from "../GraphQL.svelte";
    import { deleteProject } from "../Participaid.svelte";
    import { navigate } from "svelte-routing";
    import { createEventDispatcher } from 'svelte';
    import Project from "../models/participaid/Project.js";

    import Card, {Content, PrimaryAction, Media, MediaContent, Actions, ActionButtons, ActionIcons} from '@smui/card';
    import Button, {Label} from '@smui/button';
    import IconButton, {Icon} from '@smui/icon-button';
    import Menu, {SelectionGroup, SelectionGroupIcon} from '@smui/menu';
    import {Anchor} from '@smui/menu-surface';
    import List, {Item, Separator, Text, PrimaryText, SecondaryText, Graphic} from '@smui/list';

    import InviteContributorsDialog from "./dialogs/InviteContributorsDialog2.svelte";
    import NewEntryDialog from "./dialogs/NewEntryDialog.svelte";
    import ConfigureContributorDialog from "./dialogs/ConfigureContributorDialog.svelte";
    import Overlay from "../components/Overlay.svelte";
    import ProfilePicture from "./ProfilePicture.svelte";
    import LoadingModal from "./LoadingModal.svelte";
    import Notification from "./Notification.svelte";
    import NewParticipaidProjectDialog from "./dialogs/NewParticipaidProjectDialog.svelte";

    import RouteHelper from "../lib/route.js";

    const dispatch = createEventDispatcher();

    // data model for project
    export let model;
    export let meUserId;

    let contributors = model.contributors;

    // variable to bind the popup menu to
    let popup;

    // whether to show the colleague invitation dialog(s)
    let showInviteDialog = false;
    let showNewEntryDialog = false;
    let showConfigContributorDialog = false;
    let showEditDialog = false;

    // the deletion request
    let deleteRequest;
    let deleted = false;
    let errorMsg;

    $: showDialog = showInviteDialog || showNewEntryDialog || showConfigContributorDialog;

    // there may be a state where the card is still used,
    // so make sure we could hide it using this flag & class
    $: deleting = !!deleteRequest && !deleted;
    $: editable = model && !model.isClosed && !model.isSettled;
    $: isOwner = model && meUserId && Project.isOwner(model, meUserId);
    $: isContributorInitialized = model && meUserId && Project.isContributorInitialized(model, meUserId);
    $: meContributor = model && meUserId && Project.myContributor(model, meUserId);
    $: hasFields = model && Project.hasFieldsConfigured(model);

    $: console.info(`[ProjectCard] isOwner: ${isOwner}`);

    // create SEO-friendly project URL
    //let pageUrl = RouteHelper.participaidProjectUrl(model.company.name, model.title);
    let pageUrl = `/p/${model.id}`;

    // TODO: refactor to model/helper. Is currenlty duplicated across dialogs
    let projectHeaderBackground = model.avatarUrl || `https://picsum.photos/400/270?_pid=${model.id}`;

    function open() {
        // TODO: this issue might be worked around by breaking up the queries
        // and avoiding the user and contributor models when retrieving the projects
        if (!meContributor) {
            console.error(`A project is expected to always have a contributor entity! This is due to a bug caused by GraphQL race conditions`);
            errorMsg = "No contributor found for selected project due to GraphQL race condition bug";
        }
        else if (isContributorInitialized) {
            navigate(pageUrl, {replace: true});
        }
        else {
            showConfigContributorDialog = true;
        }
    }

    function handleNewEntryCreated(evt) {
        showNewEntryDialog = false;
        navigate(`/p/${model.id}`, { replace: true });
    }

    function handleContributorConfigured(contr) {
        let newContributor = contr.detail;
        isContributorInitialized = true;
        open();
    }

    // TODO: delete redundancy with company deletion op
    function deleteIt() {
        if (confirm("Are you sure you want to delete this Partipie? This will close the project for further entries.")) {
            deleteRequest = deleteProject(model.id)
                .then(res => {
                    console.log("successfully deleted project");
                    deleted = true;
                    dispatch("deleted", model);
                })
                .catch(err => {
                    dispatch("error", err)
                });
        }
    }

    function reload() {

    }

</script>

<Card class="project-card" style="width: 360px;">
    <LoadingModal show={deleting} global={false} background="darken"/>
    <PrimaryAction on:click={open}>
        <Media class="card-media-16x9" aspectRatio="16x9" style="background-image: url({projectHeaderBackground});">
            <MediaContent>
                <div style="color: #fff; position: absolute; bottom: 16px; left: 16px;">
                    <h2 class="mdc-typography--headline6" style="margin: 0;">{model.title}</h2>
                    <!-- TODO: company name shoujld at least be queryable if contributor is invited -->
                    <h3 class="mdc-typography--subtitle2" style="margin: 0;">{(model.company) ? model.company.name : "(Invited company)"}</h3>
                </div>
                <ul class="contributors" style="position: absolute; bottom: 0px; right: 16px; margin: 0; padding: 0; text-align: right;">
                    {#each contributors as contributor}
                        <ProfilePicture style="max-height: 25px;" user={contributor.user} border={true} />
                    {/each}
                </ul>
            </MediaContent>
        </Media>
        {#if model.description}
            <Content class="mdc-typography--body2">
                {model.description}
            </Content>
        {/if}
    </PrimaryAction>
    <Actions>
        <ActionButtons>
            {#if !editable}

            {:else if isContributorInitialized}
                <Button on:click={() => showNewEntryDialog = true} disabled={!hasFields}>
                    <Label>Add entry...</Label>
                </Button>
            {:else}
                <Button on:click={() => showConfigContributorDialog = true}>
                    <Label>Configure salary...</Label>
                </Button>
            {/if}

            {#if isOwner}
                <Button on:click={() => showEditDialog = true}>
                    <Label>Edit...</Label>
                </Button>
            {/if}
        </ActionButtons>
        <ActionIcons>
<!--            <IconButton on:click="" toggle aria-label="Add to favorites" title="Add to favorites">-->
<!--                <Icon class="material-icons" on>favorite</Icon>-->
<!--                <Icon class="material-icons">favorite_border</Icon>-->
<!--            </IconButton>-->
            {#if isOwner}
                {#if editable}
                    <IconButton class="material-icons" on:click={() => showInviteDialog = true} title="Invite">group_add</IconButton>
                {/if}
                <span>
                    <IconButton class="material-icons" on:click={() => popup.setOpen(true)} title="More options">more_vert</IconButton>
                    <Menu bind:this={popup}>
                        <List>
    <!--                        <Item on:SMUI:action={()=>{}}><Text>Cut</Text></Item>-->
    <!--                        <Item on:SMUI:action={()=>{}}><Text>Duplicate</Text></Item>-->
    <!--                        <Item on:SMUI:action={()=>{}}><Text>Paste</Text></Item>-->
    <!--                        <Separator />-->
                            <Item on:SMUI:action={deleteIt} style="background: #C00; color: white;"><Text>Delete</Text></Item>
                        </List>
                    </Menu>
                </span>
            {/if}
        </ActionIcons>
    </Actions>
</Card>

<Notification type="error" message={errorMsg} />

<Overlay show={showDialog} background="darken" closable={true} on:close={() => showInviteDialog = showNewEntryDialog = showConfigContributorDialog = false}>
    {#if showInviteDialog}
        <InviteContributorsDialog
                project={model}
                on:close={() => showInviteDialog = false}
                on:invite={() => dispatch("newContributor")}
        />
    {/if}

    {#if showNewEntryDialog}
        <NewEntryDialog
                project={model}
                {meUserId}
                on:close={() => showNewEntryDialog = false}
                on:new={handleNewEntryCreated}
        />
    {/if}

    {#if showConfigContributorDialog}
        <ConfigureContributorDialog
                projectId={model.id}
                isSelf={true}
                contributor={meContributor}
                on:new={handleContributorConfigured}
                on:update={handleContributorConfigured}
                on:close={() => showConfigContributorDialog = false}
        />
    {/if}

    {#if showEditDialog}
        <EditProjectDialog
                bind:model={model}
                on:close={() => showEditDialog = false}
        />
    {/if}
</Overlay>